export const decoratorZIndex = ({ isButton }) => isButton ? 2 : 0;
export const decoratorPointerEvent = ({ isButton, }) => (isButton ? 'auto' : 'none');
